<script>
import Modal from '@/components/atoms/Modal'
import recommendation from '@/modules/mixins/recommendation'
import ButtonLoader from '@/components/atoms/ButtonLoader.vue'
import InputLine from '@/components/atoms/inputlib/components/InputLine.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'ModalShareTracker',
    components: { InputLine, ButtonLoader, Modal },
    mixins: [recommendation],
    props: {
        token: {
            type: String,
        },
    },
    data() {
        return {
            copied: false,
        }
    },
    computed: {
        ...mapGetters({
            order: 'summary/order',
        }),
        trackingUrl() {
            const loc = window.location
            return `${loc.protocol}//${loc.host}/track/${this.token}`
        },
    },
    methods: {
        async copyLink() {
            if (navigator.permissions && navigator.permissions.query) {
                try {
                    await navigator.permissions.query({ name: 'clipboard-write' })
                } catch (_) {
                    /* unsupported, skip */
                }
            }

            await navigator.clipboard.writeText(this.trackingUrl)
            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 3000)
        },
        openModal() {
            this.$refs.modal.openModal()
        },
        closeModal() {
            this.$refs.modal.closeModal()
        },
    },
}
</script>

<template lang="pug">
  modal(ref="modal" scroll)
    template(v-slot:header)
      .modal-header-text {{ $t('order.share_tracker.modal.title') }}
    template(v-slot:body)
      .pl-1 {{ $t('order.share_tracker.modal.input_label') }}
      .d-flex.align-items-start
        input-line.flex-grow-1.mr-4(v-model="trackingUrl" readonly)
        .btn.btn-primary(@click="copyLink") {{ $t(`order.share_tracker.modal.${copied ? 'copied' : 'copy'}`) }}
      .pl-1.font-size-sm {{ $t('order.share_tracker.modal.description') }}
</template>
